<template>
  <div class="page">
    <login />
  </div>
</template>

<script>
import Login from '../layout/Login.vue';

export default {
  name: 'Index',
  components: { Login },
};
</script>

<style lang="scss" scoped>
  .page {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
